export const GLOBAL_COMMUNITY_RESET_STATE = 'GLOBAL_COMMUNITY_RESET_STATE';
export const GLOBAL_COMMUNITY_CURRENT_ITEM = 'GLOBAL_COMMUNITY_CURRENT_ITEM';

export const GLOBAL_COMMUNITY_REQUEST_LOADING = 'GLOBAL_COMMUNITY_REQUEST_LOADING';
export const GLOBAL_COMMUNITY_REQUEST_SUCCESS = 'GLOBAL_COMMUNITY_REQUEST_SUCCESS';
export const GLOBAL_COMMUNITY_REQUEST_FAILED = 'GLOBAL_COMMUNITY_REQUEST_FAILED';

export const GLOBAL_COMMUNITY_CURRENT_ACTION = 'GLOBAL_COMMUNITY_CURRENT_ACTION';
export const GLOBAL_COMMUNITY_RESET_ACTION = 'GLOBAL_COMMUNITY_RESET_ACTION';